import React from 'react';
import CONFIG from '../../../config';

import WidgetCheckbox from '../../../components/widgets/WidgetCheckbox';
import WidgetDatePicker from '../../../components/widgets/WidgetDatePicker';
import WidgetInputText from '../../../components/widgets/WidgetInputText';
import WidgetSelect from '../../../components/widgets/WidgetSelect';
import WidgetInputTextList from '../../../components/widgets/WidgetInputTextList';

import 'dayjs/locale/fr';
import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import axios from "axios";
import Base64 from 'crypto-js/enc-base64';
import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import HomeIcon from '@mui/icons-material/Home';
import Link from '@mui/material/Link';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import sha256 from 'crypto-js/sha256';
import WorkIcon from '@mui/icons-material/Work';
import CallIcon from '@mui/icons-material/Call';
import EuroIcon from '@mui/icons-material/Euro';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import GroupsIcon from '@mui/icons-material/Groups';
import WidgetProgress from '../../../components/widgets/WidgetProgress';
import Collapse from '@mui/material/Collapse';


function FicheInfo({ user }) {
  var editable = true;

  const [nom, setNom] = React.useState(null);
  const [prenom, setPrenom] = React.useState(null);
  const [email, setEmail] = React.useState(null);
  const [telephone, setTelephone] = React.useState(null);

  const formInfoPerso = [
    [nom, setNom],
    [prenom, setPrenom],
    [email, setEmail],
    [telephone, setTelephone],
  ]


  const submitQuestionnaire = () => {
    var formQuestionnaireValid = true;
    var errorPage = null;

    if (nom === null || nom.value === '') {
      setNom((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (prenom === null || prenom.value === '') {
      setPrenom((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (email === null || email.value === '') {
      setEmail((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (telephone === null || telephone.value === '') {
      setTelephone((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }


    if (!formQuestionnaireValid) {
      // setCurrentPage(errorPage);
      return;
    }


    let payload = {};

    for (var i = 0; i < formInfoPerso.length; i++) {
      let [field, setField] = formInfoPerso[i];
      if (field !== null && field.value !== null && field.value !== '') {
        payload[field.id] = dayjs.isDayjs(field.value) ? field.value.toISOString() : field.value;
      }
    }

    console.log("Save : ", payload);

    // axios.post(CONFIG.API_URL + '/api/client_submit_questionnaire', payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
    //   .then((response) => {
    //     switch (response.status) {
    //       case 200:
    //         navigate('/client/dossier');
    //         break;

    //       default:
    //         break;
    //     }
    //   })
    //   .catch((e) => {
    //     let response = e.response;

    //     console.log(response)

    //     if (response === undefined) {
    //       alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
    //       return;
    //     }

    //     switch (response.status) {
    //       case 412:
    //         setErrors(Object.keys(response.data.detail).map(key => (response.data.detail[key])));
    //         break;

    //       default:
    //         alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
    //         break;
    //     }
    //   });
  };
  const [collapse, setCollapse] = React.useState(false);

  return (
    <>
      {user &&
        <>
          <div className='max-w-4xl mx-auto shrink-0'>
            <div className='m-6 grid grid-cols-12 gap-x-4 shrink-0 max-w-4xl mx-auto bg-white my-shadow'>
              <div className={'col-span-12 grid grid-cols-12 p-6 hover:bg-gray-100 cursor-pointer ' + ((!collapse) ? 'rounded-xl' : 'rounded-t-xl')} onClick={() => setCollapse(!collapse)}>
                <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                  <div className='pr-2 text-ame-gray'>
                    <CallIcon fontSize='large'></CallIcon>
                  </div>
                  <div>
                    <h2>Informations de contact</h2>
                  </div>
                </div>
              </div>

              <div className='col-span-12 w-full px-6 rounded-b-xl shadow-inner shadow-gray-100 bg-gray-50'>
                <Collapse in={collapse}>
                  <hr className='mb-6'></hr>
                  <div className='col-span-12 w-full grid grid-cols-12 gap-4 pb-6'>
                    <div className='col-span-6 w-full mb-4'>
                      <WidgetInputText state={nom} setState={setNom} id={'nom'} text={"Nom"} value={user.nom} readOnly={!editable} />
                    </div>

                    <div className='col-span-6 w-full mb-4'>
                      <WidgetInputText state={prenom} setState={setPrenom} id={'prenom'} text={"Prénom"} value={user.prenom} readOnly={!editable} />
                    </div>

                    <div className='col-span-6 w-full mb-4'>
                      <WidgetInputText state={email} setState={setEmail} id={'email'} text={"Email"} regex={"^.+@.+$"} regex_helper={"Adresse email non-valide"} value={user.email} readOnly={!editable} />
                    </div>

                    <div className='col-span-6 w-full mb-4'>
                      <WidgetInputText state={telephone} setState={setTelephone} id={'telephone'} text={"Téléphone"} regex_key={"[+0-9 ]"} value={user.telephone} readOnly={!editable} />
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mr-0 mt-0'>
              <div className='col-span-12 w-full text-right'>
                <Button variant='contained'>
                  {(editable) ? "Enregistrer et passer à la suite" : "Suivant"}
                </Button>
              </div>
            </div>
          </div>
        </>
      }
    </>
  )
}

export default FicheInfo;